function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1509 0.00288086C10.1923 0.00143984 10.2337 0 10.2755 0C15.0941 0 19 3.90625 19 8.72449C19 8.91992 18.9915 9.1138 18.9783 9.30612H10.0816V0.00504082C10.1048 0.00448606 10.1279 0.00368328 10.1509 0.00288086ZM8.53061 10.8571H17.4273C17.4349 10.7445 17.441 10.8295 17.4447 10.8807C17.4459 10.8968 17.4468 10.9096 17.4474 10.9118C17.418 15.7002 13.5249 19 8.72449 19C3.90586 19 0 15.0938 0 10.2755C0 5.45727 3.90586 1.55102 8.72449 1.55102C8.68265 1.55102 8.64128 1.55246 8.59989 1.5539C8.57684 1.5547 8.55377 1.55551 8.53061 1.55606V10.8571Z",
  fill: "currentColor"
});

var SvgChartPie = function SvgChartPie(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChartPie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart_pie.f6320e52.svg";
export { ForwardRef as ReactComponent };